import { useCollectionsData } from 'marketplace-ui-common/collections/hooks/useCollectionsData';
import { GET_PUBLISHED_COLLECTIONS_QUERY } from 'marketplace-ui-common/collections/queries/collectionsQuery';
import { useAppContext } from '../../context/AppContext';
export function useUmbrellaCollectionSections(umbrellaCollection) {
  const appContext = useAppContext();
  const {
    data,
    requestState
  } = useCollectionsData(GET_PUBLISHED_COLLECTIONS_QUERY, {
    appContext,
    offeringType: 'APP'
  });

  // Get collections that match the umbrella collection IDs
  const matchingCollections = data.filter(collection => umbrellaCollection === null || umbrellaCollection === void 0 ? void 0 : umbrellaCollection.collectionIds.includes(collection.id));

  // Create sections for each matching collection
  const sections = matchingCollections.map(collection => ({
    collectionId: collection.id,
    collectionSlug: collection.publishedListing.slug,
    title: collection.publishedListing.title,
    description: collection.publishedListing.tagline,
    imageUrl: undefined // Collections don't have images in the current structure
  }));
  return {
    sections,
    loading: requestState === 'PENDING',
    error: requestState === 'FAILED' ? new Error('Failed to load collections') : undefined
  };
}